import {WlOption} from "./option.component";
import {defineWebComponent} from "../webcomponents-utils";

export * from './option.component';
export default WlOption;

const elementName = 'wl-option';
defineWebComponent(elementName, WlOption);
